/**
 * Function to get the query parameters from the URL
 * @returns Record of query parameters
 */
export function getQueryParams(): Record<string, string> {
  if (typeof window === 'undefined') return {};
  return Object.fromEntries(
    new URLSearchParams(window.location.search).entries(),
  );
}

